import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TabButton } from '@/Components/UI/TabButton';

import S from './styles.module.scss';

export const NotifiableFilters: FC = () => {
    const [query, setQuery] = useSearchParams();

    const handleFilterClick = (value: number | null) => {
        if (value === null) {
            query.delete('is_read');
        } else {
            query.set('is_read', value.toString());
        }

        setQuery(query);
    };

    return (
        <div className={S.filters}>
            <TabButton onClick={() => handleFilterClick(null)} isDisabled={query.get('is_read') === null} className={S.filter}>
                All Notification
            </TabButton>
            <TabButton onClick={() => handleFilterClick(0)} isDisabled={query.get('is_read') === '0'} className={S.filter}>
                Unread | Not Resolved
            </TabButton>
            <TabButton onClick={() => handleFilterClick(1)} isDisabled={query.get('is_read') === '1'} className={S.filter}>
                Read
            </TabButton>
        </div>
    );
};
